import React, { useState, useEffect } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { fopSettingsApi } from "../lib/api";

const CARD_HOLDERS = [
  { value: "Александр Собко", label: "Александр Собко" },
  { value: "Олена Собко", label: "Олена Собко" },
  { value: "Михаил Собко", label: "Михаил Собко" },
  { value: "Андрей Дубко", label: "Андрей Дубко" },
];

const BANKS = [
  { value: "Моно", label: "Моно" },
  { value: "Приват", label: "Приват" },
  { value: "А-Банк", label: "А-Банк" },
];

export const PaymentSourceSelector = ({ value, onChange }) => {
  const [sourceType, setSourceType] = useState("");
  const [sourceEntity, setSourceEntity] = useState("");
  const [sourceBank, setSourceBank] = useState("");
  const [fops, setFops] = useState([]);

  useEffect(() => {
    fopSettingsApi.getAll().then(res => {
      setFops((res.data || []).filter(f => f.is_active));
    }).catch(() => {});
  }, []);

  // Parse existing value to restore state
  useEffect(() => {
    if (!value) {
      setSourceType("");
      setSourceEntity("");
      setSourceBank("");
      return;
    }
    if (value.startsWith("Крипта")) {
      setSourceType("crypto");
    } else if (value.startsWith("Кеш")) {
      setSourceType("cash");
    } else if (value.startsWith("Р/с")) {
      setSourceType("account");
      const parts = value.split(" → ");
      if (parts[1]) setSourceEntity(parts[1]);
    } else if (value.startsWith("Карта")) {
      setSourceType("card");
      const parts = value.split(" → ");
      if (parts[1]) setSourceEntity(parts[1]);
      if (parts[2]) setSourceBank(parts[2]);
    }
  }, []);

  const buildValue = (type, entity, bank) => {
    if (type === "crypto") return "Крипта (USDT)";
    if (type === "cash") return "Кеш";
    if (type === "account" && entity) return `Р/с → ${entity}`;
    if (type === "card" && entity && bank) return `Карта → ${entity} → ${bank}`;
    if (type === "card" && entity) return `Карта → ${entity}`;
    return "";
  };

  const handleTypeChange = (type) => {
    setSourceType(type);
    setSourceEntity("");
    setSourceBank("");
    if (type === "crypto" || type === "cash") {
      onChange(buildValue(type, "", ""));
    } else {
      onChange("");
    }
  };

  const handleEntityChange = (entity) => {
    setSourceEntity(entity);
    setSourceBank("");
    if (sourceType === "account") {
      onChange(buildValue(sourceType, entity, ""));
    } else {
      onChange("");
    }
  };

  const handleBankChange = (bank) => {
    setSourceBank(bank);
    onChange(buildValue(sourceType, sourceEntity, bank));
  };

  return (
    <div className="space-y-2">
      <label className="text-xs text-zinc-500 mb-1 block">Источник оплаты</label>
      <Select value={sourceType} onValueChange={handleTypeChange}>
        <SelectTrigger className="bg-zinc-800 border-zinc-700 h-9" data-testid="source-type-select">
          <SelectValue placeholder="Выберите тип..." />
        </SelectTrigger>
        <SelectContent className="bg-zinc-800 border-zinc-700">
          <SelectItem value="crypto">Крипта (USDT)</SelectItem>
          <SelectItem value="account">Расчетный счет</SelectItem>
          <SelectItem value="card">Карта</SelectItem>
          <SelectItem value="cash">Кеш</SelectItem>
        </SelectContent>
      </Select>

      {sourceType === "account" && (
        <Select value={sourceEntity} onValueChange={handleEntityChange}>
          <SelectTrigger className="bg-zinc-800 border-zinc-700 h-9" data-testid="source-entity-select">
            <SelectValue placeholder="Выберите юр. лицо..." />
          </SelectTrigger>
          <SelectContent className="bg-zinc-800 border-zinc-700">
            {fops.map(f => (
              <SelectItem key={f.id} value={f.name}>{f.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}

      {sourceType === "card" && (
        <Select value={sourceEntity} onValueChange={handleEntityChange}>
          <SelectTrigger className="bg-zinc-800 border-zinc-700 h-9" data-testid="source-cardholder-select">
            <SelectValue placeholder="Чья карта..." />
          </SelectTrigger>
          <SelectContent className="bg-zinc-800 border-zinc-700">
            {CARD_HOLDERS.map(h => (
              <SelectItem key={h.value} value={h.value}>{h.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}

      {sourceType === "card" && sourceEntity && (
        <Select value={sourceBank} onValueChange={handleBankChange}>
          <SelectTrigger className="bg-zinc-800 border-zinc-700 h-9" data-testid="source-bank-select">
            <SelectValue placeholder="Банк..." />
          </SelectTrigger>
          <SelectContent className="bg-zinc-800 border-zinc-700">
            {BANKS.map(b => (
              <SelectItem key={b.value} value={b.value}>{b.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
};
